<template>
    <section class="">
        <div class="text-blue-800 py-4">
            Styling template: {{stylingTemplate}}
        </div>
        <div id="gjs"></div>
        <div id="blocks"></div>
    </section>
</template>

<script>
    // import grapesjs from 'grapesjs';
    // import 'grapesjs-preset-webpage';
    import '../assets/js/page_builder'
    // import {store} from "@/services/store";

    export default {
        name: "SplashPageBuilder",
        props: {
            pageId: String,
            stylingTemplate: String
        },
        data: function () {
            return {
                editor: null,
                splashPage: null,
                LandingPage: {
                    html: '',
                    css: null,
                    components: null,
                    style: null,
                },
                templateId: 1
            }
        },
        watch: {
        },
        mounted: function () {
            // this.init();
            this.editor.on('storage:load', () => {
                this.editor.render();
            });

            this.editor.on('storage:end:store', () => {
                this.$root.$emit("refresh_page", this.pageId)
            })

            this.editor.on('change', this.change);
            this.checkTemplates();
            this.getAsset();
        },
        methods: {
            // init() {
            //     this.editor = grapesjs.init({
            //         container: '#gjs',
            //         autorender: 0,
            //         components: this.LandingPage.components || this.LandingPage.html,
            //         style: this.LandingPage.style || this.LandingPage.css,
            //         plugins: [
            //             'brandfi',
            //             'gjs-preset-webpage'
            //         ],
            //         blockManager: {},
            //         storageManager: {
            //             id: '',
            //             type: 'remote',
            //             autosave: this.$store.getters.can('edit_splash_pages'),
            //             stepsBeforeSave: 1,
            //             params: {
            //                 'css_template': this.stylingTemplate
            //             },
            //             autoload: false,
            //             contentTypeJson: true,
            //             headers: {
            //                 "Authorization":"Bearer "+ store.getters.apiToken,
            //                 "orgId": store.getters.orgId
            //             },
            //             urlStore: process.env.VUE_APP_SERVER_URL + "/api/v1/splash_pages/grapejs/" + this.pageId,
            //             urlLoad: process.env.VUE_APP_SERVER_URL + "/api/v1/splash_pages/grapejs/" + this.pageId,
            //         },
            //
            //         canvas: {
            //             styles: ['https://brandfi.ams3.digitaloceanspaces.com/assets/' + this.stylingTemplate],
            //         },
            //         assetManager: {
            //             disableUpload: false,
            //             uploadFile: this.uploadAsset
            //         },
            //     });
            // },

            change() {
                this.$emit('change', this.editor.getHtml());
            },
            saveEdits() {
                this.editor.store();
            },
            checkTemplates() {
                this.editor.load();
            },
            uploadAsset(e) {
                const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
                const formData = new FormData();
                formData.append('file', files[0]); // containing all the selected images from local
                formData.append("organization_id", this.$store.getters.orgId);
                this.axios.post(process.env.VUE_APP_SERVER_URL + '/api/v1/assets', formData, {headers: {'Content-Type': 'multipart/form-data'}})
                    .then(() => {
                        this.getAsset();
                    })
                    .catch(error => error)
            },
            getAsset() {
                this.axios.get(process.env.VUE_APP_SERVER_URL + '/api/v1/assets?organization_id=' + this.$store.getters.orgId)
                    .then(response => {
                        const assets = response.data.data.files.map(file => ({
                            name: file.name,
                            src: "https://brandfi.ams3.digitaloceanspaces.com/" + file.path
                        }));
                        this.editor.AssetManager.add(assets);
                        this.editor.AssetManager.render();
                    })
                    .catch(error => error)
            }
        },
    }
</script>

<style scoped>
    @import "https://cdnjs.cloudflare.com/ajax/libs/grapesjs/0.16.12/css/grapes.min.css";
    @import "https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css";
</style>